import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { LotteryService } from "src/app/services";

@Component({
    selector: 'app-urgency-countdown-v2',
    templateUrl: 'urgency-countdown-v2.component.html',
    styleUrls: ['urgency-countdown-v2.component.html']
})
export class UrgencyCountdownV2Component implements OnInit, OnDestroy {
    
    public countdownDate: Date;

    private salestopSubscription = new Subscription();
    private lotteryService: LotteryService;
    
    public constructor(lotteryService: LotteryService) 
    {
        this.lotteryService = lotteryService;
    }

    private setCountdownDate(): void
    {
        this.salestopSubscription = this.lotteryService.getSaleStop().subscribe((result) => {
        const seconds = parseInt(result.Seconds, 10) || 0;
        const minutes = parseInt(result.Minutes, 10) || 0;
        const hours = parseInt(result.Hours, 10) || 0;
        const days = parseInt(result.Days, 10) || 0;

        const x = new Date();
        x.setDate(x.getDate() + days);
        x.setHours(x.getHours() + hours);
        x.setMinutes(x.getMinutes() + minutes);
        x.setSeconds(x.getSeconds() + seconds);

        this.countdownDate = x; 
        });
    }

    public ngOnDestroy(): void 
    {
        this.salestopSubscription.unsubscribe();
    }
    
    public ngOnInit(): void 
    {
        this.setCountdownDate();
    }
}

